<template>
    <div
        v-if="banner"
        class="o-banner"
    >
        <a :href="banner.link_url" target="_blank">
            <img
                :src="banner.name"
                alt="Agrii info"
            />
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        banner() {
            return this.$store.getters.banner
        }
    }
}
</script>